import styles from "./PurchaseHistory.module.scss";
import { useTranslation } from "react-i18next";
import { useGetAllInvoicesQuery } from "../../../../api/queries";
import { useMemo, useState } from "react";
import { Table, TableProps } from "antd";
import { IInvoiceForTable } from "../../../../models/Invoice";
import { getSubscriptionDurationType } from "../../../../helper/getSubscriptionDurationType";
import dayjs from "dayjs";

type ColumnsType<T> = TableProps<T>["columns"];

const PurchaseHistory = () => {
  const { t } = useTranslation();

  const [tableParams, setTableParams] = useState<{ current: number; pageSize: number }>({
    current: 1,
    pageSize: 10,
  });

  const { data = { totalCount: 0, data: [] }, isLoading } = useGetAllInvoicesQuery({
    pageSize: tableParams.pageSize,
    currentPage: tableParams.current,
  });

  const totalCount = useMemo(() => {
    if (!data) return 0;
    return data.totalCount;
  }, [data]);

  const handleTableChange: TableProps<IInvoiceForTable>["onChange"] = (pagination) => {
    setTableParams({
      current: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
    });
  };

  const columns: ColumnsType<IInvoiceForTable> = [
    {
      title: t("Subscription"),
      render: (data: IInvoiceForTable) => {
        if (!data.userSubscription) return `-`;
        const { name, duration, durationType, credits } = data.userSubscription.subscription;
        return `${name} / ${duration} ${getSubscriptionDurationType(durationType, duration, t)} / ${credits} ${t("Credits")}`;
      },
    },
    {
      title: t("Addon"),
      render: (data: IInvoiceForTable) => {
        if (!data.addon) return `-`;
        const { credits } = data.addon;
        return `${credits} ${t("Credits")}`;
      },
    },
    {
      title: t("Date"),
      render: (data: IInvoiceForTable) => {
        return `${dayjs(data.createdAt).format("DD/MM/YYYY")}`;
      },
    },
    {
      title: t("TotalPrice"),
      render: (data: IInvoiceForTable) => {
        return `${data.totalPrice}`;
      },
    },
  ];

  return (
    <div>
      <h2 className={styles.title}>{t("PurchaseHistory")}</h2>

      <Table
        className={"antd-table"}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data.data}
        pagination={{ ...tableParams, total: totalCount }}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default PurchaseHistory;
